// export const apiUrl = `http://100.24.158.176:4003`
// export const apiUrl = `http://127.0.0.1:8000`
// export const API_URL = 'http://64.23.149.106:8000';
// export const apiUrl = process.env.REACT_APP_API_URL_DEV;
export const apiUrl =
    process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_API_URL_DEV
        : process.env.REACT_APP_API_URL_PROD;

